import { useEffect, useState, useRef } from "react";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationsBell({ testid = "notifications-bell" }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ notifications: [], unread: 0 });
  const ref = useRef(null);

  const load = () => api.get("/notifications").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 60000);
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => { clearInterval(t); document.removeEventListener("mousedown", onClick); };
  }, []);

  const toggle = async () => {
    const next = !open;
    setOpen(next);
    if (next && data.unread > 0) { await api.post("/notifications/read-all"); load(); }
  };

  return (
    <div className="relative" ref={ref}>
      <button onClick={toggle} data-testid={testid} className="relative flex h-10 w-10 items-center justify-center rounded-full border border-[#FFE8E3] bg-white text-[#718096] transition-colors hover:text-[#FF7E67] shadow-warm">
        <Bell className="h-5 w-5" strokeWidth={2.5} />
        {data.unread > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-sunrise px-1 font-nunito text-[10px] font-bold text-white">{data.unread}</span>}
      </button>
      {open && (
        <div className="absolute right-0 z-50 mt-2 w-80 rounded-2xl border border-[#FFE8E3] bg-white p-2 shadow-warm-lg" data-testid="notifications-dropdown">
          <p className="px-3 py-2 font-nunito text-sm font-bold text-[#2D3748]">Notifications</p>
          <div className="max-h-80 overflow-y-auto">
            {data.notifications.length === 0 && <p className="px-3 py-6 text-center font-quicksand text-sm text-[#718096]">You're all caught up.</p>}
            {data.notifications.slice(0, 15).map((n) => (
              <div key={n.id} className="rounded-xl px-3 py-2.5 transition-colors hover:bg-[#FFF9F5]">
                <p className="font-quicksand text-sm font-semibold text-[#2D3748]">{n.title}</p>
                {n.body && <p className="font-quicksand text-xs text-[#718096]">{n.body}</p>}
                <p className="mt-0.5 font-quicksand text-[10px] text-[#A0AEC0]">{new Date(n.created_at).toLocaleString()}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
